import { getParam } from '../helpers'
import axios from 'axios'

export const postConfirmEmail = async () => {
  const URL = `${process.env.REACT_APP_API_CONFIRM}`

  try {
    const { data } = await axios.post(URL, {
      leadId: getParam('leadId'),
      token: getParam('token'),
    })

    if (!data) {
      return null
    }

    return data
  } catch (error) {
    console.error(error)
  }
}
